import { ActionChip, useOverlay } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import TombstonePersonDialogOverlay from './TombstonePersonDialogOverlay'

export default function TombstonePersonActionChip() {
  const { t } = useTranslation()
  const overlay = useOverlay()

  return (
    <>
      <span style={{ display: 'inline-block' }}>
        <ActionChip label={t('action.tombstone', 'Tombstone')} onClick={overlay.handleClick} selected />
      </span>
      <TombstonePersonDialogOverlay {...overlay} />
    </>
  )
}
